import { render } from "./formularioVerificacionCorreo.vue?vue&type=template&id=0747820a"
import script from "./formularioVerificacionCorreo.vue?vue&type=script&lang=js"
export * from "./formularioVerificacionCorreo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__